<template>
  <div class='contactus'>
    <ul class="ui-list ui-list-text contact">
      <li>
        <div class="contact-title">
          <span>联系电话:</span>
        </div>
        <div class="ui-list-info">{{ phone }}</div>
      </li>
     <li style="padding:1rem 0">
        <div class="contact-title">
          <span>联系地址:</span>
        </div>
        <div class="ui-list-info">{{ address }}</div>
      </li>
       <li >
        <div class="contact-title">
          <span>邮编:</span>
        </div>
        <div class="ui-list-info">{{ code }}</div>
      </li>
    </ul>
  </div>
</template>

<script>
import api from '@/script/util'
import '@/style/frozen.css'
import '@/style/base.css'
export default {
  name: '', // 联系我们
  data () {
    return {
      phone: '',
      address: '',
      code: ''
    }
  },
  created: function () {
    document.title = '联系我们'
    let params = {
      townId: api.getVal('townId')
    }
    api.GetTownInfo(params)
      .then(res => {
        console.log(res)
        this.phone = res.communityPhone
        this.address = res.communityAddress
        this.code = res.communityCode
      })
  }
}
</script>


<style scoped>
.contactus {
  margin-top: .25rem
}
.contact{
  padding: .85rem 0;
}
.ui-list-text > li, .ui-list-pure > li{
  padding: 0;
}
.contact-title{
  width: 4.75rem;
}
.contact-title span{
  padding-left: .75rem;
}
.address{
  padding: 1rem 0;
}
</style>



// WEBPACK FOOTER //
// contact.vue?95f1b56c